import cx from "classnames";
const SectionHeading = ({
  title,
  children,
  className = "",
  large
}) => {
  return <div className={cx("font-heading text-supportiveBlack rtl:font-arabic flex items-center py-4 text-sm font-medium", {
    "md:text-2xl": large,
    "md:text-xl": !large
  })} data-sentry-component="SectionHeading" data-sentry-source-file="SectionHeading.jsx">
      <span className={className}>{title}</span>
      {children && <span className="ms-auto">{children}</span>}
    </div>;
};
export default SectionHeading;